import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import {
	getQueuesResources,
	getServiceDeskSettingsResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmQueuesManageViewRoute } from '@jira/router-routes__servicedesk-queues-routes/src/csmQueuesManageViewRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { queuesManageViewEntryPoint } from '@jira/spa-apps__servicedesk-queues-manage-view/src/queuesManageViewEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const csmQueuesManageViewPageEntryPoint = createPageEntryPoint({
	main: queuesManageViewEntryPoint,
});

export const csmQueuesManageViewRouteEntry: Route = createEntry(csmQueuesManageViewRoute, () => ({
	group: 'project-settings-customer-service',
	layout: serviceProjectLayout,

	navigation: {
		sidebarId: SidebarIdProjectSettings,
	},

	resources: [...getServiceDeskSettingsResources(), ...getQueuesResources()],

	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? csmQueuesManageViewPageEntryPoint
			: notFoundPageEntrypoint;
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
